import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { Subject, filter, takeUntil } from 'rxjs';
import { LOCAL_STORAGE_KEYS, LocalStorageItemsService } from '../../services/local-storage-items.service';


@Component({
  selector: 'app-masters-tabs',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './masters-tabs.component.html',
  styleUrl: './masters-tabs.component.scss',
})
export class MastersTabsComponent implements OnInit, OnDestroy {
  activeMasterTab: string = 'employees';
  isCaratredSupervisor: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(private router: Router, private localStorageService: LocalStorageItemsService) {}

  ngOnInit(): void {
    this.localStorageService
      .getItem$(LOCAL_STORAGE_KEYS.LOGIN)
      .pipe(takeUntil(this.destroy$))
      .subscribe((userDetails: any) => {
        this.isCaratredSupervisor = userDetails?.designation === 'Caratred Supervisor';
      });
    this.checkRoute();
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd), takeUntil(this.destroy$))
      .subscribe(() => this.checkRoute());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  checkRoute(): void {
    const url = this.router.url;
    if (url.includes('/home/roles')) {
      this.activeMasterTab = 'roles';
    } else if (url.includes('/home/department')) {
      this.activeMasterTab = 'departments';
    } else if (url.includes('/home/company')) {
      this.activeMasterTab = 'company';
    } else if (url.includes('/home/modules')) {
      this.activeMasterTab = 'modules';
    } else {
      this.activeMasterTab = 'employees';
    }
  }
}
